import { init as initPasswordProtected } from "../sections/password-protected";

export function init() {
  /* Video (self-hosted) with controls */
  const passwordProtectedForm = document.getElementById('password-protection-form');
  if (passwordProtectedForm instanceof HTMLElement) {
    initPasswordProtected(passwordProtectedForm);
  }
}
